<template>
	<div class="tab_2">
		<el-row :gutter="30">
			<el-col :span="5">
				<el-menu default-active="1" @select="fnSelect">
					<el-menu-item index="1">私有云</el-menu-item>
					<el-menu-item index="2">智能设备</el-menu-item>
					<el-menu-item index="3">智能家居</el-menu-item>
					<el-menu-item index="4">农业灌溉</el-menu-item>
					<el-menu-item index="5">工业采集</el-menu-item>
				</el-menu>
			</el-col>
			<el-col :span="19">
				<div class="card">
					<div class="title" :style="{backgroundImage: 'url(' + content.pic + ')'}">
						<p>{{content.title_sub}}</p>
						<p>{{content.sub_des}}</p>
						<el-button @click="fnToRouter(content.btn.url)">{{content.btn.name}}</el-button>
						<p>应用产品</p>
						<p>
							<span @click="fnToRouter(item.url)" v-for="(item,i) in content.product" :key="i">{{item.name}}</span>
						</p>
					</div>
					<div class="content" >
						<template v-for="(item,i) in content.content">
							<h3>{{item.h}}</h3>
							<p>{{item.p}}</p>
						</template>
					</div>
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	export default {
		name: 'tab_2',
		data() {
			return {
				"sAction":"1",
				list:{
					"tab2_1":{
						"pic":require("@/assets/img/solution/tab_1_banner.png"),
						"title_sub":"私有云解决方案",
						"sub_des":"可适用于物联网私有云",
						"btn":{
							"name":"了解更多",
							"url":"/404"
						},
						"product":[
							{"name":"服务器主机","url":"/404"},
							{"name":"Qiot软件","url":"/404"},
							{"name":"Web管理后台","url":"/404"},
						],
						content:[
							{
								"h":"软硬SDN",
								"p":"支持纯软/软硬结合的SDN，所见即所得，极简操作，轻松享有属于自己的私有云环境，并提供100%的二层网络隔离，确保安全。"
							},{
								"h":"自动化部署",
								"p":"在进行横向扩展时，通过自动化部署实现即插即用。通过自动化管理工具，对应用及系统进行自动化刮泥，有效减少人力管理，切实节省时间并降低成本。"
							},{
								"h":"统一管理",
								"p":"不仅在PC端，手机端也能管理，简便的图形化工作界面，所有数据与资源都可一目了然，有效降低了管理的复杂度与人为故障的发生几率。"
							},{
								"h":"多层安全防护",
								"p":"通过密钥登陆，虚拟防火墙，安全管理等方式，达到防APP、IP欺骗、ART攻击、放DDOS攻击的效果，并确保使用过程安全稳定。"
							},
						]				
					},
					"tab2_2":{
						"pic":require("@/assets/img/solution/tab_2_banner.png"),
						"title_sub":"智能设备解决方案",
						"sub_des":"可适用于所有白电设备，净水器、空气净化器、热水器、电饭煲、风扇、空调……",
						"btn":{
							"name":"了解更多",
							"url":"/404"
						},
						"product":[
							{"name":"物联网模块","url":"/404"},
							{"name":"Qiot软件","url":"/404"},
							{"name":"Web管理后台","url":"/404"},
						],
						content:[
							{
								"h":"功能连接模块化",
								"p":"灵活连接，支持多种波特率，可自行连接传感模块、GPS定位模块等功能模块，更方便更兼容地应用于产品中，利用经过验证的成熟技术加速智能产品的上市时间。"
							},{
								"h":"多种协议轻松通讯",
								"p":"支持多种通信协议，能够更好地适配不同种类的产品。轻量级定制开发，根据设备的协议直接生成控制UI，无需开发。"
							},{
								"h":"大数据",
								"p":"数据统计，能够提供消费者使用习惯和消费者健康信息的大数据分析。"
							},{
								"h":"远程控制管理",
								"p":"配套手机端控制软件Qiot APP及Web端管理后台，可随时随地的控制和管理。企业用户可通过手机端或PC端来管理用户及产品。"
							},
						]				
					},
					"tab2_3":{
						"pic":require("@/assets/img/solution/tab_3_banner.png"),
						"title_sub":"智能家居解决方案",
						"sub_des":"可适用于智慧城市、智能教室、智能办公",
						"btn":{
							"name":"了解更多",
							"url":"/404"
						},
						"product":[
							{"name":"物联网链接器","url":"/404"},
							{"name":"Qiot软件","url":"/404"},
							{"name":"Web管理后台","url":"/404"},
						],
						content:[
							{
								"h":"超低门槛，极简操作",
								"p":"厂商无需购买服务器等软硬件设备，也无需经过漫长的实施周期，只需注册一个帐号即可使用。厂商无须任何的前期投入，节省了大量的软硬件采购成本，同时大幅缩短项目的上线周期。您既可以省去购买服务器等软硬件设施的费用，也没有系统维护成本。在使用过程中，也没有设备折旧、软件升级、维护人工、服务器电费等隐形成本。"
							},{
								"h":"互联网+",
								"p":"接入方式灵活多变，通过任意一台电脑、智能手机、平板电脑等都可以方便地访问系统。无论您是出差在宾馆，还是出游的旅途中，都可以通过互联网或手机无线网络访问系统，管理您的客户数据。"
							},{
								"h":"系统维护",
								"p":"所有的系统维护，升级等工作均由QLINK物联云在后台完成，无需用户干预。用户只需注册一个帐号即可使用，省去了系统维护，升级等麻烦，系统使用省心省力。"
							}
						]				
					},
					"tab2_4":{
						"pic":require("@/assets/img/solution/tab_4_banner.png"),
						"title_sub":"农业灌溉解决方案",
						"sub_des":"可适用于农业大棚、农田灌溉",
						"btn":{
							"name":"了解更多",
							"url":"/404"
						},
						"product":[
							{"name":"GPRS智能网关","url":"/404"},
							{"name":"Qiot软件","url":"/404"},
							{"name":"Web管理后台","url":"/404"},
						],
						content:[
							{
								"h":"集木式构建",
								"p":"采用无线扩展的开放式思路，采用先进的集木式构建。整个灌溉系统由多组集群控制单元组成，并且灌溉系统容量越大，平均投资成本就越低，生产效率就越高。"
							},{
								"h":"功能模块化",
								"p":"本系统由多组集群控制单元组成，每组集群控制单元功能模块化、层次化设计，以提高效率，增加可维护性，便于扩展。"
							},{
								"h":"大数据",
								"p":"通过多种传感器采集土壤温度、湿度，空气温度、湿度，光照强度等数据，并且可分析灌溉时某段时间的用水量、总用水量、平均用水量等数据，智能提醒灌溉，分析灌溉水量，科学节约用水。"
							},{
								"h":"统一远程控制管理",
								"p":"配套手机端控制软件Qiot APP及Web端管理后台，可随时随地的控制和管理，安全可靠。硬件更换无需更换软件，一个软件即可管理控制所有灌溉系统的被控硬件设备。"
							}
						]				
					},
					"tab2_5":{
						"pic":require("@/assets/img/solution/tab_5_banner.png"),
						"title_sub":"工业采集解决方案",
						"sub_des":"可适用于智能制造、监控监测……",
						"btn":{
							"name":"了解更多",
							"url":"/404"
						},
						"product":[
							{"name":"物联网链接器","url":"/404"},
							{"name":"Qiot软件","url":"/404"},
							{"name":"Web管理后台","url":"/404"},
						],
						content:[
							{
								"h":"手机端采集",
								"p":"突破传统PC采集的方法，以手机端APP简捷操作来采集并控制硬件，手机端智能Qiot控制软件可对任何硬件设备进行数据采集、远程控制、场景控制、定时控制。"
							},{
								"h":"简化流程",
								"p":"本方案是通过链接器经过网络直接传送数据至服务器，用手机端来显示数据和控制硬件，其中物联网链接器的接口丰富，含有RS232、RS485、TTL、继电器的接口，硬件只需接入链接器即可，链接器接入可出外网的以太网络，远程传输数据至云服务器，省去了设备端与采集器的开发与设置，直接连接后使用手机端Qiot软件即可轻松实现远程采集数据。"
							},{
								"h":"远程采集",								
								"p":"本方案的目的是以极简的架构实现远程手机端采集数据及监控，由智能的物联网链接器与Qiot软件组合使用。链接器接入可出外网的以太网络，远程传输数据至云服务器，然后使用手机端Qiot软件远程采集数据及控制设备。"
							}
						]				
					}
				
				}
			}
		},
		//计算数据
		computed: {
			content:function(){
				return this.list['tab2_' + this.sAction];
			}
		},
		//参数数据
		props: {},
		//方法
		methods: {
			fnSelect:function(index){
				this.sAction = index;
			}
		},
		//组件
		components: {},
		//生命周期-创建
		created() {},
		//生命周期-准备就绪
		mounted() {},
		//监控变量
		watch: {}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	@import url("../../assets/common.less");
	.tab_2 {
		margin-top: 20px;
		.el-col {
			.el-menu{
				background-color: #FFF;
				.el-menu-item{
					font-size:18px;
					color:#8391a5;
					transition: all .2s;
					border-bottom:1px solid #ddd;
					&.is-active{
						color: @theme-color;
						border-left: 3px solid @theme-color;
					}
				}
			}
			.card {
				min-height: 100vh;
				background-color: #FAFAFA;
				.title{
					height:300px;
					background-size:100% 100%;
					color:@theme-color;
					position: relative;
					.el-button{			
						position: absolute;
						top: 140px;
						left: 50px;
						background-color: inherit;
						color: @theme-color;
						border:@theme-color 1px solid;
					}
					p:nth-of-type(1){
						font-weight: bolder;
						left: 50px;				
						position: absolute;
						top: 20px;
						line-height: 3em;
					}
					p:nth-of-type(2){					
						position: absolute;
						top: 80px;
						left: 50px;
						width: 380px;
					}
					p:nth-of-type(3){
						position: absolute;
						bottom: 3em;
						left: 50px;
					}
					p:nth-of-type(4){
						position: absolute;
						bottom: 1em;
						left: 50px;
						span{
							margin-right: 1em;
							cursor: pointer;
						}
					}
				}
				.content{
					padding: 30px;
					color:#8391a5;
					h3{
						line-height: 3em;
						font-size: 1.1em;
						font-weight: 600;
					};
					P{
						line-height: 2em;
					}
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// tab_2.vue?62213ae5